import Vue from 'vue';

Vue.prototype.$urlAuth = process.env.VUE_APP_AUTH_ENDPOINT.replace('/api', '');
